export default {
    interest: {
        title: 'Интерес',
        type: 'interest',
        description:
            "Одна из эмоций, стимулирующих развитие человека. Насыщает человека энергией и направляет его поведение, стимулирует человека к исследовательской и познавательной активности.\n Интерес предполагает пристальное внимание, желание погрузиться в изучаемый предмет, познать все детали и тонкости. Интерес необходим, когда возникает потребность в новых знаниях. Интерес непосредственно связан с познавательной деятельность - только если нам интересно, мы можем научиться чему – то новому. Интерес – это сильнейший мотивационный фактор, который толкает нас на развитие, не дает сидеть на месте, и постоянно двигает вперед.",
        demonstration_description: '',
        demonstration: [
            'Взгляд глаза в глаза (в разговоре с другим человеком)',
            'Расширение зрачков',
            'Концентрация взгляда на интересующем объекте',
            'Слегка приподнятые брови',
            'Слегка приподнятые уголки губ: легкая улыбка',
            'Голова может быть немного наклонена',
            'Ускорение темпа речи',
            'Переживание интереса также сопровождается существенным повышением активности нейронов головного мозга.'
        ],
        functions: [
            'Мотивация к изучению конкретного объекта или работы с ним',
            'Эмоциональная экспрессия заинтересованного индивида мотивирует поведение взаимодействующих с ним людей',
            'Противостояние усталости, поддержание работоспособности',
            'Активация внимания, памяти и научения',
            'Формирует социальные связи',
        ],
        reactions: 'Человек выглядит воодушевленным, его внимание, взгляд и слух направлены на интересующий объект. Интерес сопровождается высокой степенью чувства удовольствия и чувства уверенности в себе (что порождает смелость), а также умеренной степенью импульсивности и напряжения.\n' +
            'Переживая интерес, человек всегда испытывает некоторое возбуждение. При сильном интересе – воодушевление.\n' +
            'Однако такое напряжение, которое характеризуется воодушевлением, не может присутствовать в человеке долго. Оно сменяется удовлетворением, облегчение и радостью\n',
        usage: 'Браться за новые задачи и обучаться новым умениям и навыкам. Также полезно взаимодействовать с коллективом, выносить на обсуждение идеи, мотивируя тем самым окружающих.',
    },
    expectation: {
        title: 'Ожидание',
        type:
            'expectation',
        description:
            'Позитивная эмоция, сопровождается готовностью организма к действию. Связана с активностью в направлении предполагаемого события. Состояние предвосхищения, предвкушения какой-либо ситуации. \n' +
            'Предвосхищение – это мысли, которые возникают до реального, конкретного достижения. \n' +
            'Ожидание всегда возникает, когда человек готовится к чему – либо. Ожидание тесно связано с нашим восприятием будущего, оно имеет непосредственное отношение к планам, которые мы строим и стремимся реализовать.\n',
        demonstration_description:
            '',
        demonstration:
            [
                'Эмоция ожидание имеет сходную природу с эмоцией интерес. В отличие от интереса, ожидание более сильная эмоция, проявляется активнее и ярче.',
                'Мимические проявления интереса Настороженный и напряженный взгляд'
            ],
        functions:
            [
                'Предсказывая возможное развитие событий в сложившихся обстоятельствах, ожидание',
                'играет роль внутреннего регулятора деятельности, помогающего человеку определять ее последствия и целесообразность.'
            ],
        reactions:
            'Чем сильнее выражена потребность (желание), тем сильнее выражено ожидание, которое сопровождается волнением и психической напряженностью. \n' +
            'Ожидание бывает как позитивным, так и негативным. Негативное ожидание – это тревога, когда человека одолевают плохие предчувствия. Позитивное ожидание это всегда предвкушение побед, настрой на что – то позитивное, ощущения перспективы счастья в будущем.',
        usage:
            [
                {
                    header: 'Эффективно: ',
                    body: 'Планирование и прогнозирование возможных последствий ситуации позволяют выстроить возможные шаблоны поведения, подготовиться к ситуации.'
                },
                {
                    header: 'Неэффективно: ',
                    body: 'Если ситуация не требует определенной реакции, ожидание неэффективно.'
                }
            ]
    },
    wariness: {
        title: 'Настороженность',
        type:
            'wariness',
        description:
            'Активная эмоция, психологически переживается как недоверие к чему-либо, мобилизует внутренние резервы, уводит мысли и активность человека в анализ ситуации и подготовку к «обороне»\n' +
            'Настороженность очень близко к такому понятию, как бдительность. Все системы организма приходят в боевую готовность, чтобы позволить человеку победить и\\или избежать опасности. Настороженность характеризуется отсутствием доверия, невозможностью человеку расслабится',
        demonstration_description:
            '',
        demonstration:
            [
                'Внезапное изменение позы, мимики, жестов (в разговоре с другим человеком)',
                'Немного суженные глаза, прищур',
                'Внутренняя напряженность',
                'Настороженность находится в одной группе эмоций как интерес и ожидание, и наиболее сильная из всех них. Физиологически очень часто настороженность проявляет себя как сжатие в солнечном сплетении.'
            ],
        functions:
            [
                'Предостережение от потенциальной опасности',
                'Создание определенных запретов, способствующих избеганию ожидаемых негативных последствий'
            ],
        reactions:
            'Настороженность часто возникает как реакция на нечто новое и незнакомое или на нечто, сходное с чем – то негативным, что уже было раньше.\n' +
            'Повышенная бдительность и внимательность к деталям\n' +
            'Поиск «подвоха»\n' +
            'Сосредоточение на объекте внимания и почти полная неспособность отвлечься от него',
        usage:
            'Отрицательно влияет на эффективность деятельности:\n' +
            'Настороженность на фоне сильного волнения приводит к растерянности, потери ориентиров, что отрицательно сказывается на деловой и социальной активности человека.'
    },
    serenity: {
        title: 'Безмятежность',
        type:
            'serenity',
        description:
            'Ощущение благополучия, сопровождающееся удовлетворенностью ситуацией и нежеланием ее менять\n' +
            'Перенос внимания с внешних обстоятельств на внутреннее состояние и в предпочтении разума чувствам. Является фундаментом, основой для управления эмоциями.\n' +
            'Когда человек испытывает безмятежность, он доверяет миру и не ждет от него подвохов',
        demonstration_description:
            '',
        demonstration:
            [
                'Расслабленные мышцы лица',
                'Спокойный голос',
                'Возможно – полуулыбка',
                'Нейтральное эмоциональное состояние'
            ],
        functions:
            [
                'Ослабевание причин длительного беспокойства'
            ],
        reactions:
            'Хорошая работоспособность, \n' +
            'быстрая реакция, высокий уровень смелости, способность принимать и нести ответственность\n' +
            'Человек воспринимает окружающие без аффекта, и скорее положительно.',
        usage:
            [
                {
                    header: 'Эффективно: ',
                    body: 'Благоприятное состояние для конструктивной оценки ситуации и принятия решений, требующих от индивида ответственности. Подходящая эмоция для внимательного слушания, самоанализа, достижения соглашения.'
                }
            ],
    },
    joy: {
        title: 'Радость',
        type:
            'joy',
        description:
            'Активная эмоция, характеризуется удовлетворением вследствие обладания реальным или воображаемым благом\n' +
            'Сопровождается повышением познавательной активности, переживанием удовлетворенности самим собой и окружающим миром. Способствует усилению кровотока и повышению интенсивности обмена веществ',
        demonstration_description:
            '',
        demonstration:
            [
                'Искренняя улыбка: напряжение скуловых мышц',
                'Приподнятые уголки губ (обычно длится до 4 секунд)',
                'Расходящиеся морщинки у внешнего края глаза (глаза улыбаются)',
                'Нижнее веко приподнято'
            ],
        functions:
            [
                'Мотивирует делать то, что идет нам на пользу',
                'Поощрение за осуществленную деятельность и достижение целей',
                'Возбуждение интереса',
                'Восстановление затраченной энергии',
            ],
        reactions:
            'Уверенность в себе, ощущение нужности, чувство удовольствие, отрешенность от проблем. Возможно, желание воздать эмоцию радости кому-то другому',
        usage:
            [
                {
                    header: 'Эффективно: ',
                    body: 'Благоприятная эмоция для мотивационной речи, а также для социального взаимодействия. Радость в сочетании с интересом предрасполагает к успешной конструктивной, творческой деятельности, вовлечению других людей в свои идеи и проекты.\n' +
                        'Но стоит отметить, что критическое мышление в состоянии радости имеет довольно низкий показатель. Человек в состоянии радости склонен принять объект таким, каков он есть, нежели искать в нем недостатки.'
                }
            ]
    },
    delight: {
        title: 'Восторг',
        type:
            'delight',
        description:
            'Сильная неуправляемая эмоция, человек может быть полностью захвачен этим состоянием и не реагировать на окружающие действия и процессы.\n' +
            'Эмоция восторга имеет одни корни с эмоцией радости, но восторг – это многократно усиленная радость. Восторг часто воспринимается как нечто ненормальное, нездоровое. Действительно, природа восторга – аффективна.',
        demonstration_description:
            '',
        demonstration:
            [
                'Физические ощущения (мурашки)',
                'Брови немного приподняты (как при удивлении)',
                'Широкая улыбка, уголки рта растянуты в стороны, нижняя челюсть заметно опущена',
                'Широко раскрыты глаза',
                'Обычно сопровождается заметной физической и психической активностью'
            ],
        functions:
            [
                'Подготовка к взаимодействию с новым обстоятельством',
                '«Перезагрузка системы»: переключение предшествовавшего состояния на новое'
            ],
        reactions:
            'Возбужденное состояние, ощущение эйфории, неспособность сконцентрироваться на чем-то кроме объекта, вызвавшего эмоцию.',
        usage:
            'Отрицательно влияет на эффективность деятельности:\n' +
            'Восторг неэффективен для принятия решений в силу сильного эмоционального перевеса в сторону положительных черт ситуации. Неуправляемая эмоция\n' +
            '! Но бывают ситуации, где восторг может помочь – например, выступлении на публику – восторженность оратора может заразить весь зал.'
    },
    acceptance: {
        title: 'Принятие',
        type:
            'acceptance',
        description:
            'Нейтральная эмоция, согласие с существующим положением дел, является базисом для перехода из одной эмоции в другую, создает благоприятную атмосферу. В результате принятия создается естественное, спокойное и «безоценочное» состояние\n' +
            'Начальная стадия такой эмоции, как доверие. Принятие характеризуется верой в искренность, защищенностью.',
        demonstration_description:
            'Экспрессивные проявления эмоции принятие можно вычленить только лишь косвенно. \n' +
            'Показатели принятия: ',
        demonstration:
            [
                'ровное дыхание, заинтересованный взгляд, спокойное сердцебиение, внятность и логичность мысли',
                'умение спокойно описать себя',
                'пересказать слово в слово обращенные к себе реплики, не преломляя их бессознательно через призму своих оценок и восприятий'
            ],
        functions:
            [
                'Подкрепление командного духа',
                'Формирование представлений о человеке и определение допустимой степени доверия по отношению к нему'
            ],
        reactions:
            'Принятие ни на что не мотивирует, но создает комфортную атмосферу в коллективе или между двумя людьми',
        usage: [
            {
              header: 'Положительно влияет на эффективность деятельности:',
              body: 'При наличии состояния принятия друг друга в коллективе укрепляется командный дух, который необходим на старте новых проектов и процессов.'
            }
        ],
    },
    trust: {
        title: 'Доверие',
        type:
            'trust',
        description:
            'Нейтральная эмоция, характеризуется спокойствием, гармонией, ощущением безопасности. Уверенность в чьей-либо добросовестности, при которой субъект добровольно ставит свое личное благополучие в зависимость от внешнего фактора, которому доверяет',
        demonstration_description:
            '',
        demonstration:
            [
                'Спокойная интонация',
                'Заинтересованный взгляд',
                'Человек выглядит спокойным, умиротворенным',
                'Мышцы лица разглажены, нет резких мимических реакций',
                'Направление к человеку (взгляд, тело, жесты)'
            ],
        functions:
            [
                'Наличие психологической поддержки и эмоциональной разрядки'
            ],
        reactions:
            'Тот, кому доверились чувствует ответственность за соответствие своего поведения ожиданиям того, кто доверился\n' + 'Тот, кто доверился получает возможность поделиться и получить поддержку, но зачастую полагается на какое-либо мнение, кажущееся ему авторитетным, и потому отказывается от самостоятельного исследования вопроса',
        usage:
            [
                {
                    header: 'Положительно влияет на эффективность деятельности: ',
                    body: 'В ситуации взаимного доверия эффективна постановка амбициозных целей и их достижение, обеспечиваемое взаимной поддержкой и высокой результативностью за счет слаженного командного механизма.'
                }
            ]
    },
    admiration: {
        title: 'Восхищение',
        type:
            'admiration',
        description:
            'Сильная эмоция, выражение отношения к чему-то или кому-то. Переживание, связанное с признанием человека харизматической личностью и желанием следовать за ним. При этом фигура рассматривается как в чем-то превосходящая субъекта.',
        demonstration_description:
            '',
        demonstration:
            [
                'Широко открытые глаза',
                'Немного приподнятые брови',
                'Неотрывный взгляд: глазами как будто хочется съесть, вместить в себя как можно больше.',
                'Восхищение сопровождается улыбкой, полуоткрытым ртом',
                'Жесты в сторону объекта восхищения',
            ],
        functions:
            [
                'Формирование ценностей и ориентиров, мотивирующих к развитию личностных качеств'
            ],
        reactions:
            'Сильная эмоция, выражение отношения к чему-то или кому-то. Переживание, связанное с признанием человека харизматической личностью и желанием следовать за ним.',
        usage:
            'Эффективно в ситуациях когда сопровождается еще и интересом – данный комплекс эмоций несет самое сильное мотивирующее воздействие на деятельность. Формирование ценностей и ориентиров, мотивирующих к развитию личностных качеств\n' +
            'Неэффективно – сильная эмоция, может переключать внимание с деятельности на сам объект восхищения'
    },
    anxiety: {
        title: 'Тревога',
        type:
            'anxiety',
        description:
            'Внутреннее мучительное бессодержательное беспокойство, связываемое с прогнозированием неудачи, опасности или же ожидания чего-то важного, значительного для человека в условиях неопределенности.\n' +
            'Тревога – это всегда неопределенность. Именно плохие, негативные ожидания в состоянии неясности, подвешенности, провоцируют тревогу. При тревоге опасность неясна, завуалирована. Тревога – острое, мучительное состояние. Оно забирает много психической энергии.',
        demonstration_description:
            '',
        demonstration:
            [
                'Двигательная активность',
                'Учащение сердцебиения и дыхания',
                'Увеличение артериального давления',
                'Настороженный и напряженный взгляд, направленный на объект',
                'Глаза открыты чуть шире, чем обычно'
            ],
        functions:
            [
                'Повышенное внимание к потенциальной опасности, вовлечение во внимание возможных рисков'
            ],
        reactions:
            [
                'Бегство от ситуации, инертность и пассивность, уход в себя, избегание потенциально проблемных ситуаций, безынициативность',
                'Фокусировка внимания на объекте или ситуации, сигнализирующей об опасности',
                'Попытка понять причины эмоции'
            ],
        usage:
            'Незначительная тревога действует мобилизующее. \n' +
            'Сильная интенсивность тревоги может привести к отчаянию. \n' +
            'Длительное состояние тревоги может привести к стрессу (первая стадия стресса)\n' +
            'Наиболее разумно в состоянии тревоги проверить все возможные причины потенциальной опасности и устранить их по возможности\n' +
            'При сильной тревоге мыслительная деятельность протекает медленнее, чем обычно. Если уровень тревоги невысок, то умственная деятельность наоборот протекает быстрее обычного. Это связано с тем, что человек ищет выход и сложившейся непростой ситуации.\n' +
            'Соответственно, если ситуация слишком сложна, и уровень тревоги возрастает, степень рационального анализа у человека снижается, и тревога превращается в страх'
    },
    fear: {
        title: 'Страх',
        type:
            'fear',
        description:
            'Сильная эмоция, отражает защитную реакцию человека при переживании реальной или мнимой опасности для здоровья и благополучия.\n' +
            'Страх может быть социальным – например, страх потерять уважение коллег, или же природным, врожденным – страх боли. \n' +
            'Страх – очень сильная эмоция, и многие боятся ее. (Как бы это не звучало парадоксально – бояться страха)',
        demonstration_description:
            '',
        demonstration:
            [
                'Поднятые верхние веки',
                'Губы растянуты по горизонтали',
                'Нижняя челюсть опущена',
                'Брови сильно подняты и сведены',
                'Дрожь',
                'Пантомимические комплексы вроде съеживания и попытки к бегству'
            ],
        functions:
            [
                'Мотивация к избеганию опасности',
                'Поиск помощи среди окружения, что способствует сплочению коллектива'
            ],
        reactions:
            [
                'экспрессивное поведение',
                'активация повышенного внимания',
                'физический дискомфорт: учащение сердцебиения, тяжелое дыхание, усиленное потоотделение',
                'чувство утраты контроля',
                'иногда проявляется агрессия, направленная на объект'
            ],
        usage:
            'Краткосрочно: улучшает эффективность деятельности (человека как бы подгоняет собственный страх). \n' +
            'Долгосрочно: страх негативно действует на эффективность, приводя к депрессии.\n' +
            'Важно определить конкретную проблему, вызывающую страх, и продумать пути ее избегания или разрешения, а также найти поддержку или объединиться в борьбе с проблемой с теми, кто тоже испытывает от нее дискомфорт\n' +
            'Когда человек испытывает страх, его внимание резко сужается. Оно концентрируется на объекте, который вызвал эту эмоцию, и отметает все остальное. Это так называемое «туннельное восприятие». Но страх не только ограничивает наше внимание, он также ограничивает нашу свободу. В состоянии страха мы не можем широко и глобально мыслить, следовательно, не можем принять взвешенное решение'
    },
    horror: {
        title: 'Ужас',
        type:
            'horror',
        description:
            'Крайняя форма проявления страха, при которой признается неизбежность наступления устрашающей ситуации\n' +
            'Ужас характеризуется такими понятиями, как отчаянье и безнадежность. Ужас – это полный провал, тотальное фиаско, это невозможность что – либо изменить, злой рок.',
        demonstration_description:
            '',
        demonstration:
            [
                'Чрезвычайно высокий уровень активации вегетативной нервной системы, создающий нагрузку на жизненно важные органы, которые работают на грани срыва',
                'Плач или крик',
                'Резкие непрактичные действия',
                'Возможно продолжительное оцепенение',
                'Мимические проявления страха'
            ],
        functions:
            [
                'Потребность в спасении, бегстве, защите',
                'Мобилизация организма и фокусировка на одной проблеме, вызвавшей ужас'
            ],
        reactions:
            'Возможно развитие ужаса в панику или ступор. В первом случае возникает ощущение удушья, немедленная концентрация внимания на удовлетворении потребности. При этом происходит выплеск адреналина, мобилизующий мышцы тела и способствующий усиленной мозговой деятельности. Во втором случае появляется неспособность к движению и принятию каких бы то ни было решений.',
        usage:
            'Отрицательно влияет на эффективность деятельности: из рассматриваемого ряда эмоций является самой дезорганизирующей деятельность человека. \n' +
            'Импульсивность, характерная для ужаса, может приводить к дезадаптивному поведению, к паническим реакциям, которые не помогают в устранении угрозы\n' +
            'При ужасе человек выбирает (подсознательно) одну из двух стратегий – бежать или застыть. Ужас не поддается управлению. Только успокоившись, и перейдя на уровень вначале страха, а потом уже – тревоги, можно что – то изменить в своем восприятии.'
    },
    confusion: {
        title: 'Растерянность',
        type:
            'confusion',
        description:
            'Эмоция возникает при относительно малой уверенности в правильности прошлого опыта, когда некоторое явление не согласуется с этим опытом, замешательство при столкновении с чем-то неожиданным.',
        demonstration_description:
            '',
        demonstration:
            [
                'Неуклюжесть и несвязная речь',
                'Суетливость в движениях или полное бездействие',
                'Рассосредоточенный, бегающий взгляд',
                'Физически проявляется в пожимании плечами, разведением рук.',
                'Растерянность проявляется как сомнение, колебания, нерешительность'
            ],
        functions:
            [
                'Сосредоточение на обретении контроля над собой',
                'Поиск эмоции, применимой к новому явлению'
            ],
        reactions:
            'Человек как – бы замирает, пытаясь понять окружающий мир. Также для человека в состоянии рассеянности характерны невнимательность и восприятие мира в легком хаосе.',
        usage:
            'Отрицательно влияет на эффективность деятельности\n' +
            'Человек не может разобраться в происходящем, не может понять, в чем дело. Также низок его уровень уверенности в себе. \n' +
            'При умелом управлении эмоциями, первым шагом к выходу из данного состояния является осознание причин и предмета, вызывающих это состояние.'
    },
    surprise: {
        title: 'Удивление',
        type:
            'surprise',
        description:
            'Сильная побудительная эмоция, вызванная сильным впечатлением от чего-либо поражающего неожиданностью, необычайностью, странностью.',
        demonstration_description:
            '',
        demonstration:
            [
                'Брови подняты и изогнуты',
                'Кожа под бровями натянута',
                'Поперек лба идут горизонтальные морщины',
                'Веки открыты; верхние веки подняты, нижние опущены; белок глаз — склеру — можно видеть над радужной оболочкой, а нередко и под ней',
                'Нижняя челюсть опускается, так что губы и зубы размыкаются, а рот находится в ненапряженном состоянии'
            ],
        functions:
            [
                'Подготовка к взаимодействию с новым',
                'Переключение с предшествовавшего эмоционального состояния на последующее',
            ],
        reactions:
            'Удивление длится недолго и скоро переходит в другое эмоциональное состояние. За этот промежуток определяются ожидаемые последствия',
        usage:
            'Если удивление перерастает в позитивные эмоции, эффективно дать волю интересу или радости, которые мотивируют к работе и мыслительной деятельности. Если удивление сменяется страхом или печалью, желательно устранить причины или понять их, чтобы избежать аналогичных ситуаций впредь.'
    },
    amusement: {
        title: 'Изумление',
        type:
            'amusement',
        description:
            'Возникает тогда, когда человек был абсолютно уверен в правильности предыдущих результатов мыслительного процесса и прогнозировал результаты, противоположные возникшим.',
        demonstration_description:
            '',
        demonstration:
            [
                'Изменение дыхания',
                'Покачивание головой как проявление скепсиса и недоверия',
                'Мурашки по коже',
                'Мимические проявления удивления',
            ],
        functions:
            [
                'Индикация сложно объяснимого явления и фокусировка на нем для дальнейшего определения его причин'
            ],
        reactions:
            'Испытывая изумление, человек пытается найти причины происходящего и спрогнозировать исход.',
        usage:
            'Полезнее всего найти разумные причины «изумляющему», и, возможно, взять на вооружение тот или иной механизм, который смог приятно изумить Вас. Эффективно также попытаться спрогнозировать развитие событий, чтобы противостоять состоянию шока.'
    },
    sadness: {
        title: 'Грусть',
        type:
            'sadness',
        description:
            'Эмоциональное состояние пассивного принятия неблагоприятной ситуации, возникает в случае неудовлетворенности человека в каких-либо аспектах его жизни.',
        demonstration_description:
            '',
        demonstration:
            [
                'Слегка сведенные и приподнятые внутренние уголки бровей',
                'Опущенные верхние веки',
                'Слегка опущенные уголки губ'
            ],
        functions:
            [
                'Уведомление о дисгармонии, адресованное самому человеку и его окружению',
                'Осмысление ситуации',
                'Осознание причин и путей их корректировки',
            ],
        reactions:
            'Уход от ситуации или поиск решений для устранения причин, повлекших эмоцию.',
        usage:
            'В состоянии грусти полезным будет оценить неприятную ситуацию с точки зрения совершенных действий, чтобы избежать ее в будущем, выработать альтернативные способы достижения желаемого. Грусть благоприятна для рефлексии с целью переосмыслить привычный подход к делу и вовлечь во внимание возможные его изменения\n' +
            'Грусть эффективна, когда нужно сконцентрироваться, вычитать тексты на предмет ошибок или детальный анализ.'
    },
    yearning: {
        title: 'Печаль',
        type:
            'yearning',
        description:
            'Отрицательно окрашенная эмоция, возникает после неудачи, неудовлетворения какой-либо сильной потребности, упреков со стороны с примесью разочарованности и подавленности, смежное с покорностью и чувством безнадежности.',
        demonstration_description:
            '',
        demonstration:
            [
                'Сокращение мыщц лба',
                'Нахмуренные брови, изогнутые «домиком»',
                'Слегка прищуренные глаза Приподнятые щеки',
                'Опущенные уголки губ',
                'Подтянутая нижняя губа или сжимание обеих губ',
            ],
        functions:
            [
                'Пробуждение эмпатии со стороны окружающих',
                'Осознание проблемы и поиск ее решений',
                'Возможность',
                'по-новому взглянуть на ситуацию',
                'Напоминание о значимости того, что обычно остается незамеченным',
                'Побуждение к решению проблемы'
            ],
        reactions:
            [
                'Замедление психических и соматических процессов',
                'Снижение мотивации и отсутствие интереса',
                'Снижение активности человека'
            ],
        usage:
            'Отрицательно влияет на эффективность деятельности\n' +
            'Печаль вызывает ощущение холода и озноба. Сужение мелких сосудов легких приводит к оттоку из них крови, в результате ухудшается поступление кислорода в организм и человек начинает ощущать недостаток воздуха, стеснение и тяжесть в груди (в худшем случае), в умеренном наблюдается общая заторможенность мозговой и физической активности.'
    },
    grief: {
        title: 'Горе',
        type:
            'grief',
        description:
            'Сильная дезорганизующая эмоция, активное выражение протеста, вызванное непринятием ситуации, ассоциируемое с несчастьем и скорбью.',
        demonstration_description:
            '',
        demonstration:
            [
                'Изогнутые углом вверх внутренние уголки бровей',
                'Вертикальная морщина между бровями',
                'Суженные глаза, взгляд часто направлен вниз',
                'Щеки приподняты кверху',
                'Губы вытянуты по горизонтали',
                'Невольное сокращение мышц подбородка',
                'Слезы'
            ],
        functions:
            [
                'Пробуждение эмпатии со стороны окружающих',
                'Психологическая адаптация к утрате',
                'Укрепление близости между переживающими горе, влекущее за собой наличие психологической поддержки'
            ],
        reactions:
            [
                'Утрата мотивации к чему-либо и чувство пустоты',
                'Замедление соматических процессов'
            ],
        usage:
            'Отрицательно влияет на эффективность деятельности\n' +
            'Горе является дезорганизующей эмоцией, почти как ужас. Но в отличие от ужаса, механизмы жизнеобеспечения в горе не работают на износ, на грани срыва. Они находятся в относительно спокойном состоянии. \n' +
            'Переживание горя имеет три стадии: \n' +
            '– отрицание случившегося, шок, ступор, нежелание принять происходящее, ощущение иллюзорности, как будто все просто вам сниться. \n' +
            '– плачь, причитания, стоны – все звуковые проявления этой эмоции. \n' +
            '– отчаянье, депрессия. На этой стадии часто возникает разбитость, опустошенность. \n' +
            'Наиболее эффективно разделить горе с кем-то еще для скорейшего выхода из этого состояния.'
    },
    boredom: {
        title: 'Скука',
        type:
            'boredom',
        description:
            'Эмоция, характеризующаяся снижением активности, отсутствием интереса к какой-либо деятельности, окружающему миру и другим людям\n' +
            'Скука – верный спутник монотонности. Когда человек испытывает скуку, его ничего не затрагивает из окружающего мира, ничто не возбуждает его интерес, не вызывает в нем эмоций. Состояние скуки может быть вызвано как внешними факторами, например, монотонной работой, либо же, факторами внутренними – такими, как общая опустошенность и депрессивный фон.',
        demonstration_description:
            '',
        demonstration:
            [
                'Расслабленные мышцы лица',
                'Уголки губ слегка опущены',
                'Верхнее веко слегка опущено'
            ],
        functions:
            [
                'Адаптация к обстановке: скука предупреждает, что нынешнее занятие не может полностью удовлетворить человека, и мотивирует тем самым его на поиск других действий или новых подходов к их осуществлению.'
            ],
        reactions:
            'Утрата интереса к созидательной деятельности\n' +
            'Безразличное, безучастное отношение к окружающему\n' +
            'Неудовлетворенность и чувство собственной бесполезности',
        usage:
            'Отрицательно влияет на эффективность деятельности\n' +
            'Полезнее всего в первую очередь разобраться, что именно вызывает скуку. Для того, чтобы пробудить интерес к деятельности или ситуации, можно внести что-то новое, изменить подход к выполнению работы.'
    },
    disappointment: {
        title: 'Неудовольствие',
        type:
            'disappointment',
        description:
            'Ощущение неприязни по отношению к чему-либо, сопровождающееся внутренним напряжением, одновременным проявлением легкой печали и раздражения\n' +
            'Возникает вследствие стимулов, которые кажутся неприятными. Это переживание считается базовым. Так же считается, что оно не поддается сознательному анализу в силу своей примитивной, но древней природы. Эмоция неудовольствия гораздо сильнее скуки. Если со скукой человек может мириться, то в ситуации неудовольствия человек будет стараться искать выходы, что – то, что способно переломить ситуацию.',
        demonstration_description:
            '',
        demonstration:
            [
                'Зубы стиснуты',
                'Верхнее веко слегка опущено',
                'Брови сведены вместе'
            ],
        functions:
            [
                'По отношению к человеку: выражение неприязни',
                'По отношению к действию: призыв к смене деятельности'
            ],
        reactions:
            'Неудовольствие сопровождается раздраженностью и нервозностью, а также не позволяет сконцентрироваться на объекте, вызывающем неприязнь.',
        usage:
            'Отрицательно - если задача не имеет (даже по субъективному мнению) решения или объективно человек никак не может повлиять на ситуацию, данное состояние перетекает в бездеятельность, в дальнейшем возможно в депрессию. Положительно - как «лакмусовая бумажка» говорит о необходимости изменения ситуации, стимулирует к активности.'
    },
    disgust: {
        title: 'Отвращение',
        type:
            'disgust',
        description:
            'Сильная эмоция, глубокое ощущение неприязни к чему-то, соединенное с брезгливостью, омерзением и презрением\n' +
            'Эта эмоция по психологическим характеристикам, как ни странно, близка к скуке. Но только гораздо сильнее. В основе отвращения также лежит неприязнь монотонности. \n' +
            'Отвращение формируется постепенно в течение человеческой жизни. Если вначале оно возможно только по отношению к невкусной еде (в младенчестве), то у взрослого человека может проявляться как к другим людям, так и к себе. Отвращение по отношению к работе снижает ее эффективность и темпы. Отвращение по отношению к себе приводит к депрессии, подавленным состояниям и лишает возможности человека двигаться дальше, расти и развиваться.',
        demonstration_description:
            '',
        demonstration:
            [
                'Нахмуренные брови',
                'Сморщенный нос',
                'Приподнятую верхнюю губу, угловатая форма рта'
            ],
        functions:
            [
                'Полное отвержение физически и психически вредных объектов, что предотвращает появление стресса'
            ],
        reactions:
            'Отстранение от объекта отвращения или желание его изменить\n' +
            'Может вести как к апатии и разочарованию, так и к гневу, выражению враждебности, досаде\n' +
            'Зависть успехам, интересному виду деятельности, планам других.',
        usage:
            'Отрицательно влияет на эффективность деятельности Испытывая отвращение, человек прежде всего стремится устранить объект отвращения или отстраниться от него (например, от рабочего проекта, задачи, коллеги и т.п.) \n' +
            'Эффективно любым способом найти возможность прекратить деятельность или избежать ситуации, вызывающей отвращение.'
    },
    annoyance: {
        title: 'Досада',
        type:
            'annoyance',
        description:
            'раздражение, недовольство вследствие собственной неудачи или неудачи близкого человека.\n' +
            'Сожаление часто с примесью злости на обстоятельства, себя, человека, помешавшего достижению задуманного.',
        demonstration_description:
            '',
        demonstration:
            ['По всем признакам является слабой формой злости, «разряжается» с помощью «крепких» выражений и других доступных способов выражения.'],
        functions:
            [
                'Досада всегда обращает внимание человека на ошибки, допущенные им или кем-то другим в прошлом, но которые повлекли за собой неблагоприятный исход для него.'
            ],
        reactions:
            [
                'Уход от ситуации (забыть, выкинуть из головы) или самобичевание',
                'Или разрешение ситуации и результативность'
            ],
        usage:
            'В состоянии досады будет эффективной формирование плана задач на будущее, четкая постановка задач, проговаривание и корректировка дальнейших шагов, направленность на будущее, нежели проговаривания причин сделанных ошибок\n' +
            'Именно взгляд вперед помогает оторваться от бесполезной рефлексии.'
    },
    anger: {
        title: 'Злость',
        type:
            'anger',
        description:
            'Сильное недовольство, которое возникает, когда потребности или ожидания не были удовлетворены, повышает скорость обменных процессов и активность.',
        demonstration_description:
            '',
        demonstration:
            [
                'Импульсивность, резкие движения',
                'Глаза глядят пристально и могут быть слегка выкачены наружу, нижние веки напряжены',
                "Губы могут находиться в двух основных состояниях: \n - плотно сжаты, уголки губ прямые или опущены вниз \n - «прямоугольный рот»: губы напряжены как при крике."
            ],
        functions:
            [
                'Сигнализирует о неудовлетворении потребности',
                'Позволяет тому, на кого направлена злость, понять, что субъект недоволен',
                'Позволяет выплеснуть внутреннее недовольство',
                'Показывает, что совершение тех же действий в отношении человека будет вызывать напряжение в отношениях'
            ],
        reactions:
            [
                'Повышается скорость обменных процессов и активность человека',
                'Повышается мотивация (т.к. злость является катализатором процессов)'
            ],
        usage:
            'В эмоции злости эффективно:\n' +
            '- Решать задачи, требующие активности и выносливости (злость дает силы). \n' +
            'Злость хороша во время публичного выступления или когда Вам нужно отстоять свою точку зрения – блестящие глаза оратора, активные жесты – все это привлекает внимание и стимулирует «идти за Вами». \n' +
            'Задачи, для которых злость эффективна: организации крупного мероприятия, конкурентное взаимодействие, переговоры, отстаивание интересов, своей позиции, добывать новую информацию, защита личных границ.'
    },
    rage: {
        title: 'Гнев',
        type:
            'rage',
        description:
            'интенсивная неуправляемая эмоция, сопровождается приливом сил, энергии. Это повышает уверенность в себе, уменьшает страх при наличии опасности. Характеризуется импульсивностью действий, остро наступает и скоро проходит\n' +
            'Причины гнева человека первобытного – это в первую очередь боль. Сегодня главной причиной гнева становятся непреодолимые препятствия на пути. Также гнев может вызвать обида, несправедливость.',
        demonstration_description:
            '',
        demonstration:
            [
                'Рот: зубы и губы сжаты',
                'Нос: крылья носа расширяются или сжимаются',
                'Дыхание: затрудненное',
                'Речь: сбивчивая при сдерживаемом гневе',
                'Поведение: \n -ритмическое постукивание рукой или ногой \n -более агрессивные действия\n'
            ],
        functions:
            [
                'С помощью гнева человек защищает самого себе от внешних обстоятельств',
                'Выражение гнева мотивирует людей, в сторону которых направлена агрессия, анализировать свое поведение',
                'Гнев мобилизует силы для психологической атаки',
                'Служит для защиты личного достоинства, сохранения личностной целостности'
            ],
        reactions:
            [
                'Человек становится склонным к импульсивным поступкам',
                'Желание отомстить',
                'Склонность к аморальным действиям',
                'Умышленный неоправданный поступок',
            ],
        usage: [
            {
                header: 'Отрицательно влияет на эффективность деятельности:',
                body: 'во время вспышки гнева не работают почти все известные методы управления эмоциями. \n' +
                    'Эволюционное значение гнева состоит в мобилизации энергии для активной самозащиты индивида. Он сопровождается приливом сил, энергии (за счет выброса в кровь адреналина, способствующего мобилизации энергоисточников организма). Это повышает уверенность в себе, уменьшает страх при наличии опасности. Но при ярости мобилизация энергии и возбуждение столь велики, что человек чувствует, что он взорвется, если «не откроет клапан и не выпустит из себя пар». Человек становится склонным к импульсивным поступкам, готовым напасть на источник гнева или проявить агрессию в вербальной форме.'
            }
        ],
    },
    embarrassment: {
        title: 'Смущение',
        type:
            'embarrassment',
        description:
            'замешательство, ощущение неловкости, уязвимости и несоответствия требованиям конкретной ситуации. Всегда связано с чувством неуверенности, которое возникает в ситуации социального взаимодействия.',
        demonstration_description:
            '',
        demonstration:
            [
                'учащенный сердечный ритм',
                'чаще всего',
                'кратковременная улыбка, после которой человек прячет глаза или отворачивается',
                'человек украдкой посматривает на смутившего его человека',
            ],
        functions:
            [
                'Предохраняет от излишне легкого сближения и вступления в контакт с незнакомыми людьми',
                'Стимулирует повышенный самоконтроль и самоотчет',
            ],
        reactions:
            [
                'характеризуется обострением самоосознания',
                'ощущение беззащитности в ситуации социального взаимодействия',
                'человек воспринимает критику или неприятие любого своего действия так, как если бы объектом критики была его личность',
                'состояние рассеянности, непонимание, что делать,'
            ],
        usage: [
            {
                header: 'Отрицательно влияет на эффективность деятельности:',
                body: 'Интенсивное и частое переживание смущения обременительно для человека. Смущение ограничивает любознательность и препятствует исследовательскому поведению в социальных ситуациях, мешает налаживанию контактов.'
            }
        ],
    },
    shame: {
        title: 'Стыд',
        type:
            'shame',
        description:
            'Осознание собственной неумелости, непригодности или неадекватности в некой ситуации или при исполнении некоего задания. Ощущение непереносимого отвержения себя или своего поступка.',
        demonstration_description:
            '',
        demonstration:
            [
                'Стыдящийся человек нередко заикается, становится неуклюжим, страшно гримасничает',
                'Стремление сжаться и сделаться как можно меньше',
                'Глаза опущены или бегают из стороны в сторону',
                'Наклоненная голова',
                'Появление румянца',
            ],
        functions:
            [
                'Поддерживает чувство собственного достоинства, самоуважение и эмоциональные связи человека, предостерегая от совершения «постыдных» поступков',
                'Активирует самооценку и самокритичность'
            ],
        reactions: 'Стыдясь, человек ощущает повышение самосознания, однако может утрачивать самоконтроль. Он осознает свою общую несостоятельность, некомпетентность, отвергнутость, потерю достоинства. Человек ощущает себя объектом презрения и насмешки, он чувствует себя смешным, униженным.',
        usage:
            [
                {
                    header: 'Неэффективно: ',
                    body:
                        'При стыде все сознание человека сфокусировано только ситуации, в которой он оказался. Ему кажется, что все то, что он скрывал от посторонних глаз, неожиданно оказалось выставленным на всеобщее обозрение, и он оказался нагим, беззащитным, беспомощным. Собственно самокопание и уход являются причиной потери ориентиров и векторов деятельности\n' +
                        'Эмоции вины и стыда очень похожи, но все – таки они различаются. Если эмоция стыда затуманивает сознание человека, от вина наоборот – делает его острым, наполняет вниманием, стимулирует мыслительные процессы – все это происходит с целью найти выход, который бы помог исправить ситуацию.'
                }
            ]
    },
    guilt: {
        title: 'Вина',
        type:
            'guilt',
        description:
            'Отрицательно окрашенная эмоция, осознание собственной причастности к нанесению какого-либо вреда, сопровождающееся сожалением и желанием компенсировать ущерб',
        demonstration_description:
            '',
        demonstration:
            [
                'расслабленные мышцы лица',
                'полуопущенные веки',
                'слегка опущенные уголки губ',
                'взгляд обращен вниз',
                'слегка сведенные брови',
            ],
        functions:
            [
                'Стимулирует к исправлению ситуации',
                'Служит «расплатой» за плохой поступок, повышая тем самым социальную ответственность'
            ],
        reactions:
            'Вина побуждает человека осознать свое поведение по отношению к другому человеку как неправильное и попытаться найти пути устранения этой проблемы и восстановить прежнюю доверительность отношений.',
        usage:
            [
                {
                    header: 'Эффективно: ',
                    body:
                        'стимулирует мыслительные процессы, связанные с осознанием провинности и с перебором возможностей для исправления ситуации. \n' +
                        'Человек мотивирован исправить ошибку, собственно и из-за того чтобы это чувство трансформировалось в более позитивное для человека \n' +
                        'Очень важно разобраться в совершенной ошибке, чтобы не совершать ее впредь. Не всегда эффективно идти на уступки, поскольку под давлением эмоции «компенсация» может значительно превзойти нанесенный ущерб и навредить самому субъекту.'
                }
            ]
    },
};